export const SET_VAT = "SET_VAT";
export const SET_LANGUAGES = "SET_LANGUAGES";
export const RESET_VAT = "RESET_VAT";
export const SET_SPECIFIC_VAT = "SET_SPECIFIC_VAT";
export const RESET_SPECIFIC_VAT = "RESET_SPECIFIC_VAT";
export const SET_VAT_LANGUAGES = "SET_VAT_LANGUAGES";
export const SET_SETUP = "SET_SETUP";
export const RESET_SETUP = "RESET_SETUP";
